/**
 * PosteingangVorschau – Rechte Spalte: Dokumentenvorschau
 */
import React from 'react';
import { Button } from '@/components/ui/button';
import { FileText, Eye } from 'lucide-react';

const BACKEND_URL = process.env.NODE_ENV === 'production' ? '' : (process.env.REACT_APP_BACKEND_URL || '');

export default function PosteingangVorschau({ selectedDoc }) {
  return (
    <div className="w-96 shrink-0 flex flex-col bg-white rounded-xl border border-slate-200 overflow-hidden">
      <div className="p-3 border-b border-slate-200 bg-slate-50">
        <p className="text-sm font-medium text-slate-700 flex items-center gap-2">
          <Eye className="w-4 h-4" /> Vorschau
        </p>
      </div>
      <div className="flex-1 overflow-hidden bg-slate-100 min-h-[400px]">
        {selectedDoc?.datei_url ? (
          (selectedDoc.dateityp === '.pdf' || selectedDoc.dateiname?.toLowerCase().endsWith('.pdf')) ? (
            <object
              data={`${BACKEND_URL}${selectedDoc.datei_url}`}
              type="application/pdf"
              className="w-full h-full min-h-[500px] border-0"
              style={{ minHeight: '500px' }}
              data-testid="doc-preview-pdf"
            >
              <iframe
                src={`https://docs.google.com/viewer?url=${encodeURIComponent(BACKEND_URL + selectedDoc.datei_url)}&embedded=true`}
                className="w-full h-full min-h-[500px] border-0"
                title="PDF Vorschau"
                style={{ minHeight: '500px' }}
              />
            </object>
          ) : (selectedDoc.dateityp?.match(/\.(jpg|jpeg|png|gif|webp)$/i) || selectedDoc.dateiname?.match(/\.(jpg|jpeg|png|gif|webp)$/i)) ? (
            <div className="w-full h-full flex items-center justify-center p-4" data-testid="doc-preview-image">
              <img
                src={`${BACKEND_URL}${selectedDoc.datei_url}`}
                alt="Vorschau"
                className="max-w-full max-h-full object-contain rounded shadow-lg"
              />
            </div>
          ) : (selectedDoc.dateityp?.match(/\.(txt|text|md|csv)$/i) || selectedDoc.dateiname?.match(/\.(txt|text|md|csv)$/i)) ? (
            <iframe
              src={`${BACKEND_URL}${selectedDoc.datei_url}`}
              className="w-full h-full min-h-[500px] border-0 bg-white"
              title="Text Vorschau"
              style={{ minHeight: '500px' }}
              data-testid="doc-preview-text"
            />
          ) : (
            <div className="flex-1 flex items-center justify-center text-slate-400 h-full" data-testid="doc-preview-unsupported">
              <div className="text-center">
                <FileText className="w-12 h-12 mx-auto mb-2" />
                <p className="text-sm">Vorschau nicht verfügbar</p>
                <p className="text-xs mt-1">Typ: {selectedDoc.dateityp || 'unbekannt'}</p>
              </div>
            </div>
          )
        ) : (
          <div className="flex-1 flex items-center justify-center text-slate-400 h-full" data-testid="doc-preview-empty">
            <div className="text-center">
              <FileText className="w-12 h-12 mx-auto mb-2" />
              <p className="text-sm">Dokument auswählen</p>
            </div>
          </div>
        )}
      </div>
      {selectedDoc?.datei_url && (
        <div className="p-2 border-t border-slate-200 bg-slate-50">
          <Button
            size="sm"
            variant="outline"
            className="w-full"
            onClick={() => window.open(`${BACKEND_URL}${selectedDoc.datei_url}`, '_blank')}
          >
            <Eye className="w-4 h-4 mr-1" /> Im neuen Tab öffnen
          </Button>
        </div>
      )}
    </div>
  );
}
